const languageStorage = () => {
  const storage = localStorage.getItem("lang") ? localStorage.getItem("lang") : localStorage.setItem("lang", "tr");
  return storage;
};
export default languageStorage;
